import { useState } from 'react';
import { checkin } from '@/mocks/gossip';

export default function CheckinCard() {
  const [checkedIn, setCheckedIn] = useState(false);
  const [streak, setStreak] = useState(checkin.streakDays);

  const handleCheckin = () => {
    if (checkedIn) {
      setCheckedIn(false);
      setStreak((v) => Math.max(0, v - 1));
      return;
    }
    setCheckedIn(true);
    setStreak((v) => v + 1);
  };

  const weekProgress = streak % 7 === 0 && streak > 0 ? 7 : streak % 7;

  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
      <div className="flex items-center gap-2 text-secondary-700 text-xs mb-2">
        <i className="ri-calendar-check-line"></i>
        评论区打卡
      </div>
      <h3 className="font-heading text-xl text-foreground-950">连续打卡 {streak} 天</h3>
      <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
        在任意话题下留下一句话，就算完成当日打卡。历史最长连续 {checkin.bestStreak} 天。
      </p>

      <div className="mt-5 flex items-center gap-2">
        {Array.from({ length: 7 }).map((_, index) => {
          const day = index + 1;
          const done = day <= weekProgress;
          return (
            <span
              key={day}
              className={`flex-1 h-2 rounded-full ${done ? 'bg-secondary-500' : 'bg-background-200'}`}
              aria-hidden="true"
            ></span>
          );
        })}
      </div>
      <p className="mt-2 text-xs text-foreground-500">本轮进度 {weekProgress}/7 天</p>

      <button
        type="button"
        onClick={handleCheckin}
        className={`mt-5 w-full py-3 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
          checkedIn
            ? 'bg-secondary-100 text-secondary-900'
            : 'bg-secondary-500 text-background-50 hover:bg-secondary-600'
        }`}
      >
        {checkedIn ? '今日已打卡 · 点击撤销' : '今日打卡'}
      </button>

      <div className="mt-5 pt-5 border-t border-background-200 space-y-3">
        {checkin.rewards.map((reward) => (
          <div key={reward.id} className="flex items-center justify-between gap-3">
            <span className="flex items-center gap-2 text-sm text-foreground-700">
              <i className={`${reward.days <= streak ? 'ri-gift-fill text-primary-500' : 'ri-gift-line text-foreground-400'}`}></i>
              {reward.label}
            </span>
            <span className={`text-xs ${reward.days <= streak ? 'text-primary-600' : 'text-foreground-500'}`}>
              {reward.days <= streak ? '已解锁' : `还差 ${reward.days - streak} 天`} · {reward.reward}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}